import {
  Box,
  Button,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  InputAdornment,
  TableCell,
  tableCellClasses,
  TableRow,
  TextField,
} from "@mui/material";
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SearchIcon from "@mui/icons-material/Search";
import styled from "styled-components";
import "../../CSS/ManageUsers.css";
import {
  deleteCustomerUser,
  getCustomerUsers,
} from "../../redux/actions/CustomerAction";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import NotificationPopup from "../../Components/NotificationPopup";

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#282828",
    color: "#ffffff",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(() => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "#e8e9eb",
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function createData(
  id,
  created_at,
  first_name,
  last_name,
  email,
  username,
  contact_number,
  pccs
) {
  return {
    id,
    created_at,
    first_name,
    last_name,
    email,
    username,
    contact_number,
    pccs,
  };
}

export default function ManageUsers(props) {
  const { decodedToken } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const hasAccess = (allowedRoles) => allowedRoles.includes(decodedToken?.role);

  const cust_login_id = JSON.parse(localStorage.getItem("customer_login_id"));

  const [row, setRow] = useState();
  const [deleteCustomerUserId, setDeleteCustomerUserId] = useState(null);
  const [notificationOpen, setNotificationOpen] = useState(false);
  const [notificationMessage, setNotificationMessage] = useState("");
  const [notificationSeverity, setNotificationSeverity] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [dialogOpen, setdialogOpen] = useState(false);
  const rowsPerPage = 10; // Number of rows per page

  const GetCustomerUsers = useSelector((state) => state.GetCustomerUsers);
  const { customerUsersInfo, loading, error } = GetCustomerUsers;

  const DeleteCustomerUser = useSelector((state) => state.DeleteCustomerUser);
  const { deleteCustomerUserInfo, deleteCustomerUserError } =
    DeleteCustomerUser;

  const handleDialogOpen = () => {
    setdialogOpen(true);
  };

  const handleDialogClose = () => {
    setdialogOpen(false);
  };

  // Pagination logic: slice the data based on current page
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = row?.slice(indexOfFirstRow, indexOfLastRow);

  const handleNextPage = () => {
    if (currentPage < Math.ceil(row?.length / rowsPerPage)) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {
    dispatch(getCustomerUsers(cust_login_id));
  }, [dispatch, cust_login_id]);

  useEffect(() => {
    if (customerUsersInfo) {
      setRow(
        customerUsersInfo.map((user) =>
          createData(
            user.cust_user_id,
            user.created_at,
            user.first_name,
            user.last_name,
            user.email,
            user.username,
            user.contact_number,
            user.pccs
          )
        )
      );
    }
  }, [customerUsersInfo]);

  useEffect(() => {
    if (deleteCustomerUserInfo) {
      setNotificationOpen(true);
      setNotificationMessage(deleteCustomerUserInfo);
      setNotificationSeverity("success");
    }
    if (deleteCustomerUserError) {
      setNotificationOpen(true);
      setNotificationMessage(deleteCustomerUserError);
      setNotificationSeverity("error");
    }
  }, [deleteCustomerUserInfo, deleteCustomerUserError]);

  return (
    <div className="wrap-mu">
      <div className="container">
        <div style={{ padding: "20px" }}>
          <div className="aditdeluser">
            <h2>Edit/Delete User</h2>
            <div className="header-container">
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "10px",
                }}
              >
                <div className="srchbox">
                  <TextField
                    type="text"
                    placeholder="Search"
                    onChange={(e) => {
                      dispatch(getCustomerUsers(cust_login_id, e.target.value));
                    }}
                    variant="outlined"
                    size="small"
                    style={{ width: "100%" }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="dt-mu-wrap">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Created At</th>
                  <th>First Name</th>
                  <th>Last Name</th>
                  <th>Email</th>
                  <th>Username</th>
                  <th>Contact Number</th>
                  <th>PCCS</th>
                  <th>Edit</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {currentRows?.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td>{row.created_at}</td>
                    <td>{row.first_name}</td>
                    <td>{row.last_name}</td>
                    <td>{row.email}</td>
                    <td
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "100px",
                      }}
                    >
                      {row.username}
                    </td>
                    <td>{row.contact_number}</td>
                    <td
                      style={{
                        wordWrap: "break-word",
                        maxWidth: "400px",
                      }}
                    >
                      {row.pccs}
                    </td>
                    <td>
                      <IconButton
                        id="editbtnroq"
                        color="primary"
                        onClick={() =>
                          navigate(`/dashboard/users/add-new-user/${row.id}`)
                        }
                      >
                        <EditIcon />
                      </IconButton>
                    </td>
                    <td>
                      <IconButton
                        id="editbtnroqdel"
                        color="error"
                        onClick={() => {
                          setDeleteCustomerUserId(row.id);
                          setdialogOpen(true);
                        }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Pagination buttons */}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
            }}
          >
            <Button
              className="btnpernext"
              variant="outlined"
              onClick={handlePrevPage}
              disabled={currentPage === 1}
              style={{ marginRight: "10px" }}
            >
              Previous
            </Button>
            <Button
              className="btnpernext"
              variant="outlined"
              onClick={handleNextPage}
              disabled={currentPage === Math.ceil(row?.length / rowsPerPage)}
            >
              Next
            </Button>
          </div>
        </div>
      </div>

      {notificationOpen && (
        <NotificationPopup
          open={notificationOpen}
          severity={notificationSeverity}
          message={notificationMessage}
          onClose={() => {
            setNotificationOpen(false);
            dispatch({ type: "DELETE_CUSTOMER_USER_RESET" });
          }}
        />
      )}
      <Dialog
        open={dialogOpen}
        onClose={handleDialogOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Opps!</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this user?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>No</Button>
          <Button
            onClick={() => {
              dispatch(deleteCustomerUser(deleteCustomerUserId)).then(() => {
                dispatch(getCustomerUsers(cust_login_id));
                handleDialogClose();
              });
            }}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
